import React from 'react';
import Icon from '../../../../molecules/Icon';
import { color } from '../../../../atoms/colors';
import { Container } from '../styles/Success.styled';

const Success = () => (
  <Container>
    <Icon
      id="circle-check-01"
      fillColor={color.primary[700]}
      classes="valid-icon"
    />
    <p>Thank you for your Nomination!</p>
  </Container>
);

export default Success;
